<template>
  <full-container v-loading="loading">
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form
        ref="ff"
        size="small"
        :inline="true"
        :model="queryParams"
        class="search-form"
      >
        <el-form-item>
          <el-input
            v-model="queryParams.keyWord"
            clearable
            placeholder="单号/客户/备注"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--表格-->
    <el-table ref="tb" :data="datalist.Items" height="100%" size="mini" border>
      <el-table-column label="客户单位" min-width="200" fixed>
        <template slot-scope="{ row }">
          <el-popover>
            <p class="text-bold">{{ row.Client }}</p>
            <p>联系地址:{{ row.Address }}</p>
            <el-link
              slot="reference"
              class="text-cut"
              @click="$router.push({ path: `detail`, query: { id: row.Id } })"
            >
              <el-tag size="mini" v-if="!row.CustomerId"> 新 </el-tag>
              {{ row.Client }}
            </el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="Linkman"
        label="联系人"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="Linktel"
        label="联系电话"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column prop="Explain" label="客户需求" min-width="200">
        <template slot-scope="{ row }">
          <span class="text-cut">{{ row.Explain }}</span>
        </template>
      </el-table-column>
      <el-table-column label="预计销售金额" min-width="120">
        <span
          class="text-price"
          slot-scope="{ row }"
          v-if="row.ProAmount > 0"
          >{{ row.ProAmount }}</span
        >
      </el-table-column>
      <el-table-column label="预计签单日期" min-width="120">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row?.ProDealDate) }}
        </template>
      </el-table-column>
      <el-table-column label="线索类别" min-width="80" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ $utils.meta.format("demand-type", row.Type) }}
        </template>
      </el-table-column>
      <el-table-column label="线索来源" min-width="80">
        <template slot-scope="{ row }">
          {{ $utils.meta.format("demand-from", row.Source) }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="140">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.CreateTime, "{y}-{m}-{d} {h}:{i}") }}
        </template>
      </el-table-column>
      <el-table-column label="管理员" prop="User" min-width="80" show-overflow-tooltip/>
      <el-table-column fixed="right" label="状态" width="120" align="center">
        <template slot-scope="{ row }">
          <el-link
            type="primary"
            @click="$router.push({ path: `form`, query: { id: row.Id } })"
          >
            修改
          </el-link>
          <el-link type="primary" @click="onGrab(row)">截单</el-link>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div slot="footer" class="toolbar">
      <el-pagination
        background
        :page-size="datalist.PageSize"
        :current-page="datalist.PageIndex"
        :total="datalist.TotalCount"
        @current-change="onSearch"
      />
    </div>
  </full-container>
</template>
  
<script>
export default {
  data() {
    return {
      loading: false,
      datalist: {},
      currentTarget: {},
      queryParams: {
        index: 1,
        size: 20,
        free: true,
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    // 查询参数
    onSearch(val = 1) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.job.demand
        .list(this.queryParams)
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //截单
    onGrab(row) {
      this.$confirm("此操作将独占商机信息, 是否继续?", "截单", {
        center: true,
      }).then(() => {
        this.$apis.job.demand
          .grab({ id: row.Id })
          .then(() => {
            this.loadData();
            this.$message({ message: "数据提交成功！", type: "success" });
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
  },
};
</script>